export default __webpack_public_path__ + "assets/images/active.2b713e.webp";